import { render, staticRenderFns } from "./showAccRecords.vue?vue&type=template&id=775ef3da&scoped=true&"
import script from "./showAccRecords.vue?vue&type=script&lang=js&"
export * from "./showAccRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ef3da",
  null
  
)

export default component.exports